import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { KidsBuchungMlInfoComponent } from './kids-buchung-ml-info.component';
import { MngWarningContainerComponent } from '@mng/mng-base-ui';
import { MatButton } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';

export interface IKidsTerminFristAbgelaufenParams {
  actionType: string;
}

@Component({
  imports: [
    MatDialogContent,
    MatDialogActions,
    KidsBuchungMlInfoComponent,
    MatButton,
    MatDialogClose,
    MatDialogTitle,
    MngWarningContainerComponent,
    MatDivider
  ],
  templateUrl: './kids-termin-frist-abgelaufen.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KidsTerminFristAbgelaufenComponent {
  dialogRef = inject<MatDialogRef<KidsTerminFristAbgelaufenComponent>>(MatDialogRef);
  data = inject<IKidsTerminFristAbgelaufenParams>(MAT_DIALOG_DATA);
}
